import { SortDirection } from '@ddt-web/common';

export class TableHeader {
	constructor(
		private headerText: string,
		private type: HeaderType,
		private allowsSorting: boolean,
		private sortingDirection: SortDirection
	) { }

	public getHeaderText(): string {
		return this.headerText;
	}

	public getType(): HeaderType {
		return this.type;
	}

	public isSortingAllowed(): boolean {
		return this.allowsSorting;
	}

	public getSortingDirection(): number {
		return this.sortingDirection;
	}

	public nextSortingDirection(): void {
		const isUnsorted: boolean = this.sortingDirection === SortDirection.UNSORTED;
		const isSortedAsc: boolean = this.sortingDirection === SortDirection.ASC;

		if (isUnsorted) {
			this.sortingDirection = SortDirection.ASC;
		} else if (isSortedAsc) {
			this.sortingDirection = SortDirection.DESC;
		} else {
			this.sortingDirection = SortDirection.ASC;
		}
	}

	public setSortingDirection(direction: number): void {
		this.sortingDirection = direction;
	}
}

export enum HeaderType {
	NAME,
	LAST_MODIFIED,
	TYPE
}
